import { antecedentesApi } from "../view/antecedentes.service";

export const editAntecedente = antecedentesApi.injectEndpoints({
  endpoints: (builder) => ({
    editAntecedente: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/v1/api/antecedenteacademico/${id}/`,
        method: "PATCH",
        body: rest,
      }),
      invalidatesTags: (result, error, { id }) =>
        result
          ? [
              { type: "Antecedentes", id },
              { type: "Antecedentes", id: "LIST" },
            ]
          : [{ type: "Antecedentes", id: "LIST" }],
    }),
  }),
});

export const { useEditAntecedenteMutation } = editAntecedente;
